import { useCallback } from 'react';
import { focusWithoutScrolling } from '../../libs/dom-utils';
export function useClearButton(props, inputRef) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled, readOnly = props.readOnly;
    var isInteractive = !(readOnly || disabled);
    var isActive = isInteractive && Boolean(value);
    var onPress = useCallback(function () {
        if (inputRef.current) {
            focusWithoutScrolling(inputRef.current);
            var syntheticEvent = Object.create({});
            syntheticEvent.target = inputRef.current;
            syntheticEvent.currentTarget = inputRef.current;
            inputRef.current.value = '';
            onChange === null || onChange === void 0 ? void 0 : onChange(syntheticEvent);
        }
    }, [inputRef, onChange]);
    return {
        isActive: isActive,
        buttonProps: {
            disabled: disabled,
            onPress: onPress,
            preventFocusOnPress: true,
            tabIndex: -1,
        },
    };
}
